<div class="full-height full-width p-16">
  <ag-grid-angular class="ag-theme-vdw full-width ag-details-grid" [class.loading]="loadingForTheFirstTime" [gridOptions]="detailOptions"></ag-grid-angular>
</div>
